import React, {useEffect, useState} from 'react'
import Header from '../../../Layout/Header'
import Footer from '../../../Layout/Footer'
import { Outlet } from 'react-router-dom'
import Preloader from "../../../Components/Preloader/Preloader";
import "./Wrapper.css"

const Wrapper = () => {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setTimeout(() => {
      setLoading(false);
    }, 2000);
  }, []);
  return (
    <>
    {loading===true ? <Preloader/>:(
    <div className="Wrapper">
    <Header />
    <Outlet />
    <Footer />
  </div>
  )}
    
</>
    
  )
}

export default Wrapper;